import _tokens from './tokens.js'
import { extractUnits } from './utils.js'

import { UnitType } from '@exodus/currency'

const name = 'vechainthor'
const displayName = 'VeChain'
const ticker = 'VET'
const displayTicker = 'VET'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const feeAssetName = 'vethor'
const primaryColor = '#A377CF'
const gradientColors = ['#A377CF', '#1CB6FB']
const gradientCoords = { x1: '7.686%', y1: '7.744%', x2: '149.648%', y2: '133.936%' }
const chainBadgeColors = gradientColors

const units = {
  wei: 0,
  VET: 18,
}
const currency = UnitType.create(units)

const assetType = 'VECHAIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://explorer.vtho.net/#/accounts/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://explorer.vtho.net/#/transactions/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'VeChainThor is an enterprise-focused blockchain ecosystem that aims to enhance supply chain management by connecting blockchain technology with the real world through a comprehensive governance structure, a robust economic model, and advanced IoT integration.',
  reddit: 'https://www.reddit.com/r/Vechain/',
  twitter: 'https://twitter.com/vechainofficial',
  website: 'https://www.vechain.org/',
  telegram: 'https://t.me/vechain_official_english',
}

export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  feeAssetName,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated
  properTicker: displayTicker, // deprecated
  ticker,
  toString: () => name,
  units,
}

export const tokens = _tokens.map((token) => {
  const units = extractUnits(token)
  return {
    ...token,
    // name,
    // displayName,
    // decimals,
    // ticker,
    // primaryColor,
    // gradientColors
    // gradientCoords
    assetType: 'VECHAIN_TOKEN',
    baseAssetName,
    blockExplorer,
    chainBadgeColors: token.chainBadgeColors || token.gradientColors,
    contract: token.addresses,
    currency: UnitType.create(units),
    displayNetworkName,
    displayNetworkTicker,
    displayTicker: token.displayTicker || token.ticker,
    feeAssetName,
    info: token.info || {},
    properName: token.displayName, // deprecated
    properTicker: token.displayTicker || token.ticker, // deprecated
    toString: () => token.name,
    units,
  }
})

export default [asset, ...tokens]
